import api from '@/api'

const state = {
  ideas: [],
  newestIdea: null
}

const actions = {
  async getIdeas ({commit}, ideasData) {
    await api.getIdeas(ideasData, ideas => {
      commit('indexIdeas', ideas)
    }, error => {
      console.log('could not pull list of ideas')
      console.log(error)
    })
  },
  async storeIdea ({commit}, ideaData) {
    await api.storeIdea(ideaData, idea => {
      commit('createIdea', idea)
    }, error => {
      console.log('could not add that new idea')
      console.log(error)
    })
  },
  async updateIdea ({commit}, ideaData) {
    await api.updateIdea(ideaData, idea => {
      console.log('updated idea', idea)
      commit('editIdea', idea)
    }, error => {
      console.log('could not update that idea')
      console.log(error)
    })
  },
  async deleteIdea ({commit}, ideaId) {
    await api.deleteIdea(ideaId, response => {
      console.log(response)
      commit('removeIdea', ideaId)
    }, error => {
      console.log('could not delete that idea')
      console.log(error)
    })
  }
}

const mutations = {
  indexIdeas (state, ideas) {
    state.ideas = ideas
  },
  createIdea (state, idea) {
    state.ideas.unshift(idea)
    state.newestIdea = idea
  },
  editIdea (state, idea) {
    state.ideas = state.ideas.filter(eachIdea => { return eachIdea._id !== idea._id })
    state.ideas.unshift(idea)
  },
  removeIdea (state, ideaId) {
    state.ideas = state.ideas.filter(eachIdea => { return eachIdea._id !== ideaId })
  }
}

const getters = {
  ideas (state) {
    return state.ideas
  },
  newestIdea (state) {
    return state.newestIdea
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/ideas.js